import React, { Component } from 'react';
import { setAndGetAttributes } from './FormInputFunctions';
// import Datetime from 'react-datetime';
import moment, { months } from 'moment';
import 'react-datetime/css/react-datetime.css';
import { getDateFormat } from '../../Utils/UserFunctions';
import { isSet } from '../../Utils/CommonFunctions';
import Wrp from "../../hoc/Wrp/Wrp";
import MomentUtils from '@date-io/moment';
import { correctSegmentValue, getDefaultValue, getSegmentPositions, shouldPad } from '../../Utils/DateUtils';

import {
  TimePicker,
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
// cyan lightBlue
import blue from "@material-ui/core/colors/blue";

class TimePick extends Component {
  constructor() {
    super();
    this.state = {
      errorMSg: false,
      displayValue: "",
      selectedMoment: null
    };
  }
  
  fieldOnChangeHandler = (moment) => {
    const { changeHandler, attributes } = this.props;
    console.log(" moment -" , moment);
    
    this.setState({
      errorMSg: moment === null ? true : false
    })

    if (isSet(moment, null) !== null && typeof moment.format === "function") {
      const systemFormat = moment.format((isSet(attributes.putDateFormat, null) !== null) ? attributes.putDateFormat : 'hh:mm A');
      //moment.format('YYYY-MM-DDTHH:MM:ss'); //2021-02-28T23:55:15
      this.setState({
        // displayValue: moment.format('hh:mm a') ,
        displayValue: systemFormat,
        selectedMoment: moment// update local display
      });
      changeHandler(systemFormat);
    } else {
      this.setState({
        displayValue: '',
        selectedMoment: null // clear display, or keep last string if needed
      });
      changeHandler(null);
    }
  }

  render() {
    const { value } = this.props;
    let attr = setAndGetAttributes(this.props);
    const timeFormat = (attr.getDateFormat !== undefined) ? attr.getDateFormat : 'hh:mm A';
    // let dispValue = '';
    // if (timeFormat === 'UNIX') {
    //   // dispValue = (isSet(value, null) !== null) ? moment(value).format('hh:mm A') : '';s
    //   dispValue = (isSet(value, null) !== null) ? moment(value) : '';

    // } else {
    //   // dispValue = (value !== '' && value !== undefined) ? moment(value, timeFormat, true).format('hh:mm A') : null;
    //   dispValue = (isSet(value, null) !== null) ? moment(value).format('hh:mm a') : '';
    // }
    // let displayMoment = null;

    // if (isSet(value, null) !== null) {
    //   const m = moment(value, timeFormat, true);
    //   if (m.isValid()) {
    //     dispValue = m.format('hh:mm a'); 
    //     displayMoment = m;
    //   } else {
    //     // Avoid invalid date rendering when format is broken (e.g., __ instead of AM/PM)
    //     dispValue = '';
    //     displayMoment = null;
    //   }
    // }
    let dispValue = '';
    let displayMoment = null;

    if (isSet(value, null) !== null) {
      if (timeFormat === 'UNIX') {
        const m = moment(value);
        if (m.isValid()) {
          dispValue = m.format('hh:mm A');
          displayMoment = m;
        }
      } else {
        const m = moment(value, timeFormat, true);
        if (m.isValid()) {
          dispValue = m.format('hh:mm A');
          displayMoment = m;
        }
      }
    }

    const materialTheme = createTheme({
      palette: {
        primary: blue,
      },
    });

    const handleKeyDown = (e) => {
      e.preventDefault()
      const input = e.target;
      const key = e.key;
      const format = 'hh:mm A'
      // const separator = format.match(/[^A-Za-z0-9]/)?.[0] || '/';
      const segments = getSegmentPositions(format, 'time');

      let cursor = input.selectionStart;
      let value = input.value || getDefaultValue(format, 'time');
      console.log("valie--",value);

      const isDigit = /^\d$/.test(key);

      const isControl = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(key);

      /// for handling the am/pm
      if (cursor === 6 && ['a', 'A', 'p', 'P'].includes(key)) {
        this.setState({
          errorMSg: false
        })
        const meridiem = key.toLowerCase() === 'a' ? 'AM' : 'PM';
        value = value.slice(0, 6) + meridiem;

        input.value = value;
        input.setSelectionRange(8, 8); // end of string

        const momentDate = moment(value, format, true);
        if (momentDate.isValid()) {
          this.fieldOnChangeHandler?.(momentDate);
        } else {
          this.fieldOnChangeHandler?.(null);
        }
        return
      }

      const ampmSegment = segments.find(seg => seg.part === 'AM');
      if (ampmSegment && cursor >= ampmSegment.start && cursor <= ampmSegment.end && !isControl) {
        // If it's *not* a valid meridiem key and *not* a control key, enforce 'pm'
        if (!['a', 'A', 'p', 'P'].includes(key)) {
            e.preventDefault();
            
            // Set value to 'pm'
            const pmString = 'PM';
            value = value.slice(0, ampmSegment.start) + pmString + value.slice(ampmSegment.end);
            
            input.value = value;
            input.setSelectionRange(ampmSegment.end, ampmSegment.end); // Move cursor out
            
            const momentDate = moment(value, format, true);
            if (momentDate.isValid()) {
              this.fieldOnChangeHandler?.(momentDate);
            } else {
              // This shouldn't happen if we force 'pm' and hours/minutes are present
              this.fieldOnChangeHandler?.(null);
            }
            this.setState({ errorMSg: false });
            return;
        }
      }

      let didPad = false;
      const currentSegment = segments.find(seg => cursor >= seg.start && cursor <= seg.end);
      if (!currentSegment) return;

      const segIndex = segments.indexOf(currentSegment);
      const { start: segStart, end: segEnd } = currentSegment;
      const segLength = segEnd - segStart;
      const segVal = value.slice(segStart, segEnd);//end -1

      if (!isDigit && !isControl) {
        e.preventDefault();
        return;
      }
      if (isDigit) {
        e.preventDefault();
        console.log(" is digit inside ");

        let positionInSegment = cursor - segStart;
        let segChars = segVal.split('');

        const isSegmentFullyFilled = !segChars.includes('_') && !segChars.includes(' ');
          
       
        // If segment is full, start fresh on first key press
        if (isSegmentFullyFilled && positionInSegment === 0) {
          segChars = Array(segLength).fill('_');
        }

        // Shift left and insert new key at cursor
        segChars.splice(positionInSegment, 0, key);
        segChars = segChars.slice(0, segLength); // Ensure segment length
        const rawUpdated = segChars.join('').replace(/_/g, '');

        const segmentType = currentSegment.type;
        const digitsOnly = value.replace(/[^\d]/g, '');

        // Auto-pad logic
        if (shouldPad(segmentType, rawUpdated, digitsOnly)) {
          segChars = rawUpdated.padStart(segLength, '0').split('');
        }

        let updatedSegment = segChars.join('').padEnd(segLength, '_');
        // const digitsOnly = value.replace(/[^\d]/g, '');

        if (shouldPad(currentSegment.part, updatedSegment.replace(/_/g, ''), segChars.join(''))) {
          const corrected = correctSegmentValue(currentSegment.part, updatedSegment, digitsOnly);
          updatedSegment = corrected.padEnd(segLength, '_');

          didPad = true;
        }
        // console.log('currentSegment',updatedSegment);
        value = value.slice(0, segStart) + updatedSegment + value.slice(segEnd);
        input.value = value;

        const newCursor = segStart + positionInSegment + 1;

        requestAnimationFrame(() => {
          if (didPad && segIndex < segments.length - 1) {
            // Move to next segment if padding was applied
            const next = segments[segIndex + 1];
            input.setSelectionRange(next.start, next.end);
          } else {
            // const newCursor = segStart + positionInSegment + 1;
            if (newCursor < segEnd) {
              input.setSelectionRange(newCursor, newCursor);
            } else if (segIndex < segments.length - 1) {
              const next = segments[segIndex + 1];
              input.setSelectionRange(next.start, next.end);
            } else {
              input.setSelectionRange(segStart, segEnd);
            }
          }
        });

        const momentDate = moment(value, format, true);
        if (momentDate.isValid()) {
          this.fieldOnChangeHandler?.(momentDate);
        }
        return;
      }

      if (key === 'Backspace') {
        e.preventDefault();
        let newValue = value;
        let newCursor = cursor;
        let currentIndex = segIndex;
        // Special handling for AM/PM clearing
        const ampmSegment = segments.find(seg => seg.part === 'AM');
        if (
          ampmSegment &&
          cursor >= ampmSegment.start
        ) {
          e.preventDefault();
          const cleared = '__';
          const newValue =
            value.slice(0, ampmSegment.start) +
            cleared +
            value.slice(ampmSegment.end);

          input.value = newValue;
          input.setSelectionRange(ampmSegment.start, ampmSegment.start);

          // requestAnimationFrame(() => {
          //   this.fieldOnChangeHandler(null); // Clear parent state
          // });

          // return; // Exit handler early
        }

        while (currentIndex >= 0) {
          const seg = segments[currentIndex];
          const segVal = newValue.slice(seg.start, seg.end);
          const isCleared = /^[_\s]*$/.test(segVal);

          if (!isCleared) {
            const cleared = '_'.repeat(seg.end - seg.start);
            newValue = newValue.slice(0, seg.start) + cleared + newValue.slice(seg.end);
            newCursor = seg.start;
            break;
          }
          currentIndex--;
        }

        input.value = newValue;
        const allCleared = segments.every(seg => {
          const segVal = newValue.slice(seg.start, seg.end);
          return /^[_\s]*$/.test(segVal);
        });

        requestAnimationFrame(() => {
          input.setSelectionRange(newCursor, newCursor);
          if (allCleared) {
            this.fieldOnChangeHandler(null);
          }
        });

        return;
      }

      if (key === 'ArrowRight' && segIndex < segments.length - 1) {
        e.preventDefault();
        const next = segments[segIndex + 1];
        input.setSelectionRange(next.start, next.end);
        return;
      }

      if (key === 'ArrowLeft' && segIndex > 0) {
        e.preventDefault();
        const prev = segments[segIndex - 1];
        input.setSelectionRange(prev.start, prev.end);
        return;
      }
    };

    const handleFocusOrClick = (e) => {
      const format = 'hh:mm A';
      const input = e.target;
      if (!input.value) {
        input.value = getDefaultValue(format, 'time');
        try {
          input.setSelectionRange(0, 0);
        } catch (e) {
          // handle error silently
        }
      } else {
        const segments = getSegmentPositions(format, 'time');
        const cursor = input.selectionStart || 0;
        const seg = segments.find(s => cursor >= s.start && cursor <= s.end) || segments[0];
        try {
          input.setSelectionRange(seg.start, seg.end);
        } catch (e) {
          // handle error silently
        }
      }
    };

    return (
      <Wrp>
        <ThemeProvider theme={materialTheme}>
          <MuiPickersUtilsProvider utils={MomentUtils} >
            <KeyboardTimePicker
              fullWidth
              autoOk
              // helperText={this.state.errorMSg && <span className="text-danger">Invalid Time</span>}
              helperText={
                this.state.errorMSg &&
                this.state.displayValue.trim().length > 0 &&
                <span className="text-danger">Invalid Time</span>
              }

              keyboard
              clearable
              defaultValue={null}
              // margin="normal"
              // value={(isSet(this.props.value, null) !== null) ? moment(this.props.value, 'hh:mm A') : null}
              value={this.state.selectedMoment || displayMoment}
              //this.state.selectedDate}//attr.value}
              // disablePast
              onChange={this.fieldOnChangeHandler}
              label=""
              // clearable={true}
              InputProps={{
                className: 'form-control',
                style: { fontSize: '0.8rem', borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px', paddingLeft: '4px' },
                disableUnderline: true,
                ...attr,
                autoComplete: 'off',
                placeholder: "hh:mm A",
                onFocus: handleFocusOrClick,
                onClick: handleFocusOrClick,
                onKeyDown: (e) => { handleKeyDown(e) }

              }}
              // readOnly={readonlyVal} 
              //  variant={'inline'}       
              // showTodayButton 
              format={'hh:mm A'}
            />
          </MuiPickersUtilsProvider>
        </ThemeProvider>
        {/* <Datetime
            closeOnSelect={true}
            value={dispValue}
            inputProps={{...attr,autoComplete:'off'}}
            onChange={this.fieldOnChangeHandler}
            timeFormat= {getDateFormat()}
            timeFormat={false}
        /> */}
      </Wrp>
    );
  }
}

TimePick.defaultProps = {
  isMandatory: false,
  className: 'form-control'
}

export default TimePick;